import { useRoute, Link } from "wouter";
import Header from "@/components/Header";
import { ChevronLeft, MessageSquare } from "lucide-react";
import { FeedbackChat } from "@/components/FeedbackChat";

export default function FeedbackThreadPage() {
  const [, params] = useRoute("/feedback/:id");
  const feedbackId = params?.id ?? "";

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Header />
      <div className="container mx-auto w-full max-w-2xl flex-1 px-4 pb-12 pt-4">
        <Link href="/messages" className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground">
          <ChevronLeft className="h-4 w-4" />
          Messages
        </Link>
        <div className="mt-3 flex items-center gap-2">
          <MessageSquare className="h-5 w-5 text-primary" />
          <h1 className="font-display text-xl font-bold text-foreground">Your bug report</h1>
        </div>
        {feedbackId ? (
          <FeedbackChat feedbackId={feedbackId} showReportContext />
        ) : (
          <p className="mt-6 text-muted-foreground">Report not found.</p>
        )}
      </div>
    </div>
  );
}
